import { render } from "./borlio-feedback.vue?vue&type=template&id=e4ce2064&scoped=true"
import script from "./borlio-feedback.vue?vue&type=script&lang=js"
export * from "./borlio-feedback.vue?vue&type=script&lang=js"

import "./borlio-feedback.vue?vue&type=style&index=0&id=e4ce2064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ce2064"]])

export default __exports__